import React from 'react';
import './comment-post.style.css';
import axios from 'axios'
import UserContext from '../../utils/userContext'
import { CommentEditSegment } from '../comment-card/comment-card.component';
import { Button, Header, Icon, Modal } from 'semantic-ui-react'
import 'dayjs/locale/th'

var dayjs = require('dayjs')

const dateCommentFormat = (date) => {
    const thaiMonth = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ษ", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
    var formattedDate = (dayjs(date))
    return (formattedDate['$D'] + " " + thaiMonth[formattedDate['$M']] + " " + (543 + formattedDate['$y']))
}



class ParentComment extends React.Component {
    static contextType = UserContext;


    constructor(props) {
        super(props);
        this.state = {
            showCommentEditor: false,
            actionToEditor: ""
        }
        this.onSavePost = this.onSavePost.bind(this)
    }

    onReplyClick() {
        if (this.state.actionToEditor !== "reply") {
            this.setState({ showCommentEditor: true })
            this.setState({ actionToEditor: "reply" })
        } else {
            this.setState({ showCommentEditor: !this.state.showCommentEditor })
        }
    }

    onEditClick() {
        if (this.state.actionToEditor !== "edit") {
            this.setState({ showCommentEditor: true })
            this.setState({ actionToEditor: "edit" })
        } else {
            this.setState({ showCommentEditor: !this.state.showCommentEditor })
        }
    }

    onSavePost() {
        this.setState({ showCommentEditor: false })
    }

    onDeleteClick() {
        var self = this
        return axios({
            method: "delete",
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.parentComment.contentId}/comments/${this.props.parentComment.commentId}?full=${this.props.fullComment}`,
            data: { "userId": this.context.userData.id },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(function (response) {
                self.props.onUpdateComments(response.data.commentData)
            })
            .catch(function (response) {
                // console.log(response);
                return response.data;
            });
    }

    onVoteClick() {
        var self = this
        return axios({
            method: "post",
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.parentComment.contentId}/comments/${this.props.parentComment.commentId}/vote?full=${this.props.fullComment}`,
            data: { "currentStatus": this.props.parentComment.voteSent },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(function (response) {
                // console.log("hey!")
                self.props.onUpdateComments(response.data.commentData)
            })
            .catch(function (response) {
                // console.log(response);
                return response.data;
            });
    }

    render() {

        var date = dateCommentFormat(this.props.parentComment.updated)
        return (
            <div>
                <div className="comment-post-wrap">
                    <div className="comment-post-container">
                        <div className="comment-post-head">
                            <div className="comment-post-author">
                                <div className="comment-post-author-image" style={{ backgroundImage: `url(${this.props.parentComment.authorImage})` }}>
                                </div>
                                <div className="comment-post-author-name">
                                    {this.props.parentComment.authorName}
                                </div>
                            </div>
                            <div className="comment-post-date">
                                {date}
                            </div>
                        </div>
                        <div className="comment-post-data">
                            <pre className="comment-post-des">
                                {this.props.parentComment.commentText}
                            </pre>
                            <div className="comment-post-action">
                                <div>
                                    {this.context.userData.loggedIn ? <span className={this.props.parentComment.voteSent === "0" ? "vote-button unvote-comment" : "vote-button voted-comment"} onClick={this.onVoteClick.bind(this)}>❤</span> : <span className=" unloggedin-comment">❤</span>} {this.props.parentComment.vote}
                                </div>
                                {this.context.userData.loggedIn ?
                                    <div>
                                        {this.context.userData.id == this.props.parentComment.authorId && this.props.parentComment.status != "deleted" ? <span><span className="edit-button" onClick={this.onEditClick.bind(this)}>แก้ไข</span> &nbsp; <span className="delete-button" onClick={this.onDeleteClick.bind(this)}>ลบ</span> &nbsp;</span> : ""}
                                        <span className="comment-post-reply-button" onClick={this.onReplyClick.bind(this)}>ตอบกลับความเห็นนี้</span>
                                    </div>
                                    :
                                    ""
                                }
                            </div>

                            {this.state.showCommentEditor ? <CommentEditSegment contentId={this.props.parentComment.contentId} fullComment={this.props.fullComment} replyToCommentId={this.props.parentComment.commentId} actionToEditor={this.state.actionToEditor} onHideEditor={this.onSavePost} onUpdateComments={this.props.onUpdateComments} prevComment={this.state.actionToEditor === "edit" ? this.props.parentComment.commentText : ""} /> : ""}


                        </div>
                    </div>
                    <div className="comment-post-child">
                        {this.props.parentComment.reply.map((eachChildComment, idx) => <ParentComment key={idx} fullComment={this.props.fullComment} parentComment={eachChildComment} onUpdateComments={this.props.onUpdateComments} />)}
                    </div>
                </div>
            </div>
        )
    }
}

class CommentPost extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            fullComment: "first",
            openModal: true
        }
        this.onUpdateComments = this.onUpdateComments.bind(this)
    }

    onUpdateComments(updatedComments) {
        // console.log("update")
        this.setState({ comments: updatedComments })
    }

    componentDidMount() {
        var self = this;
        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.contentName}/comments?full=false`,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                if (response.data.moreComments === true) {
                    self.setState({ comments: response.data.commentData, fullComment: "more" })
                } else {
                    self.setState({ comments: response.data.commentData, fullComment: "nomore" })
                }

            })
            .catch(function (response) {

            });
    }

    onfullCommentClick() {
        if (this.state.fullComment === "more") {
            this.setState({ fullComment: "nomore" })
            this.getFullComment()
        }
    }

    getFullComment() {
        var self = this
        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.contentName}/comments?full=true`,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                self.setState({ comments: response.data.commentData })
            })
            .catch(function (response) {

            });
    }
    onConfirm() {
        // console.log("sss")
    }

    setOpen(open) {
        this.setState({ openModal: open })
    }

    render() {
        // console.log("I'm here")
        return (
            <div className="comment-wrap">

                        <div>
                            {this.state.comments.map((parentComment, i) => <ParentComment key={i} fullComment={this.state.fullComment} parentComment={parentComment} onUpdateComments={this.onUpdateComments} />)}

                            {this.state.fullComment === "more" ? <button onClick={this.onfullCommentClick.bind(this)} className="all-comment-button">ดู Comment ที่เหลือ</button> : ""}
                            {this.context.userData.loggedIn ?
                                <div className="comment-post-creator-wrap">

                                    <CommentEditSegment contentId={this.props.contentId} replyToCommentId="0" actionToEditor="create" onUpdateComments={this.onUpdateComments} prevComment="" />
                                </div>
                                : ""}
                        </div>
            </div>
        )
    }
}


export { CommentPost }
